<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-05-25 10:08:29
 * @LastEditors: 邹腾 teng.zou@ruthus.com
 * @LastEditTime: 2023-07-13 16:03:40
-->
<template>
  <div :class="['model', type, theme]" :style="model">
    <div :class="['modelTitle', type]" :style="{ backgroundColor: bColor, color: textColor }">{{ title }}</div>
    <div class="modelBg">
      <div :class="['list', type]">
        <div
          :class="['item', item.addType, { spacing: item.spacing, borderTop: item.top, borderBottom: item.bottom, borderAll: item.top && item.bottom, video: item.addType == 'video' }]"
          v-for="(item, index) in data" :key="index" @click="toUrl(item)">
          <template v-if="item.addType == 'video'">
            <div class="video-box" v-if="item.videoWidth > item.videoHeight">
              <!-- <img class="itemImg" :src="item.img" /> -->
              <video class="itemVideo" ref="video1" preload controls playsinline webkit-playsinline
                x5-video-player-fullscreen x5-video-player-type="h5" :src="item.video" :poster="item.img">
              </video>
            </div>
            <div v-else>
              <div class="video-box2" @click="playVideo(index + 1)">
                <img class="itemImg" :src="item.img" />
                <i class="play-icon"></i>
              </div>
              <div class="full-video-box" v-show="isPlay">
                <video class="itemVideo" :ref="`video${index + 1}`" preload controls playsinline webkit-playsinline
                  x5-video-player-fullscreen x5-video-player-type="h5" :src="item.video">
                </video>
                <img class="close" @click="clickClose(index + 1)"
                  src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
              </div>
            </div>
          </template>
          <template v-else-if="item.addType == 'picture'">
            <img class="itemImg" :src="item.img" />
            <div class="go-btn" v-if="item.linkType == 2 && item.linkUrl && item.linkOriginalId">
              <wx-open-launch-weapp :username="item.linkOriginalId" :path="item.linkUrl" @error="handleErrorFn"
                @launch="handleLaunchFn">
                <script type="text/wxtag-template">
                  <style>
                      .btn{
                        width: 750px;
                        height: 9999px;
                      }
                    </style>
                    <div class="btn"></div>
                  </script>
              </wx-open-launch-weapp>
            </div>
          </template>
          <template v-else-if="item.addType == 'sign'">
            <div class="name">{{ item.name }}</div>
            <div class="info">
              <div class="label">报名时间</div>
              <div class="intro">{{ $util.parseTime(item.signUpStartTime,'{m}月{d}日 {h}:{i}:{s}') }} ~ {{ $util.parseTime(item.signUpEndTime,'{m}月{d}日 {h}:{i}:{s}')   }}</div>
            </div>
            <div class="info">
              <div class="label">活动时间</div>
              <div class="intro">{{$util.parseTime(item.startTime,'{m}月{d}日 {h}:{i}:{s}')   }} ~ {{ $util.parseTime(item.endTime,'{m}月{d}日 {h}:{i}:{s}')   }}</div>
            </div>
            <div class="info">
              <div class="label">活动地址</div>
              <div class="intro">{{ item.address }}</div>
            </div>
            <div class="info">
              <div class="label">活动说明</div>
              <div class="intro">{{ item.remark }}</div>
            </div>
            <div class="info">
              <div class="label">报名人数</div>
              <div class="intro">已报名<span :style="{ color: bColor }">{{ item.signUpTotal || 0 }}</span>人
                <template v-if="item.totalSwitch">
                  限报<span>{{ item.total }}</span>人
                </template>
              </div>
            </div>

            <div class="button" v-if="!item.signUpFlag" :style="{ backgroundColor: bColor, color: '#fff' }" @click="handleSign(item)">
              <img class="icon" src="https://assets.rurushishi.com/activies/activityCenter/signIcon.png" />
              立即报名
            </div>
            <div class="button" v-else :style="{ borderColor: bColor, color: bColor }" @click="handleSign(item)">
              查看预约
            </div>

            <div class="signUserList" v-if="item.signList&&item.signList.length>0">
              <div class="title" :style="{ color: bColor }">
                <div class="line" :style="lineStyle"></div>
                已报名
                <div class="line" :style="lineStyle"></div>
              </div>
              <div class="userList">
                <div class="item" v-for="(v,index) in item.signList" :key="`signItem${index}`">
                  <img class="userImg"
                    :src="v.headImgUrl || 'https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/avatar.png'" />
                  <div class="userName">{{ v.nickname || "微信用户" }}</div>
                  <div class="time">{{ $util.parseTime(v.receiveTime,'{m}-{d} {h}:{i}:{s}')  }}</div>
                </div>
              </div>
              <div class="more" :style="moreStyle" v-if="item.signList.length>5">滑动查看更多</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/common";
import wx from "weixin-js-sdk";
import { handlerYqAnalyticsEvent } from "@/utils/biz";

export default {
  props: ["data", "bColor", "title", "textColor", "type", "theme"],
  data() {
    return {
      iswx: false,
      isMiniApp: false,
      name: "1",
      info: "",
      longitude: "121.31296",
      latitude: "31.19402",
      telephoneNumber: "1",
      img: "",
      linkSwitch: 0,
      linkType: 1,
      linkUrl: "",
      linkOriginalId: "",
      isPlay: false,
    };
  },
  watch: {
    data: {
      handler(val) {
        const leng = val.length;
        val.map((item, index) => {
          let top = false;
          let bottom = false;
          top = index > 0 ? item.spacing : true;
          bottom = index + 1 < leng ? val[index + 1].spacing : true;
          console.log(top, bottom);
          item.top = top;
          item.bottom = bottom;
        });
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.iswx = util.browser.versions.wx;
    let _this = this;
    console.log(wx);
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        _this.isMiniApp = true;
      } else {
        _this.isMiniApp = false;
      }
    });
  },
  computed: {
    model() {
      if (this.type == "lightup") {
        return { backgroundColor: `${this.bColor}80` };
      } else if (this.type == "purchase") {
        return { border: `none`, backgroundColor: '' }
      }
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.5),
        };
      }
      return {
        borderColor: this.bColor,
      };
    },
    lineStyle() {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.2),
        };
    },
    moreStyle() {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.1),
          color:this.bColor
        };
    },
  },
  methods: {
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn(e) {
      handlerYqAnalyticsEvent("actClick", {
        type: 'customModule',
        linkUrl: 'launch',
        actCode: this.$actCode,
        nickName: this.$userInfo.nickname,
        mobile: sessionStorage.getItem("mobile") || ''
      });
      console.log("success", e);
    },
    toUrl(item) {
      if (item.linkSwitch == 0) return;
      if (item.linkType == 1) {
        handlerYqAnalyticsEvent("actClick", {
          type: 'customModule',
          linkUrl: item.linkUrl,
          actCode: this.$actCode,
          nickName: this.$userInfo.nickname,
          mobile: sessionStorage.getItem("mobile") || ''
        });
        if (item.linkUrl.indexOf("http://") < 0 && item.linkUrl.indexOf("https://") < 0) window.location.href = "https://" + item.linkUrl;
        else {
          window.location.href = item.linkUrl;
        }
      }
      // if (!item.navLink) return;
      // if (
      //   item.navLink.indexOf("http://") < 0 &&
      //   item.navLink.indexOf("https://") < 0
      // )
      //   window.location.href = "https://" + item.navLink;
      // else {
      //   window.location.href = item.navLink;
      // }
    },
    nav(item, type) {
      if (type == "tel") {
        window.location.href = `tel:${item.telephoneNumber}`;
      }
      if (type == "nav") {
        window.location.href = `https://uri.amap.com/marker?position=${item.longitude},${item.latitude}&name=${item.address}&src=mypage&coordinate=gaode&callnative=0`;
      }
    },
    goAppUrl(link) {
      if (!link) {
        return false;
      }
      wx.miniProgram.navigateTo({
        url: `/${link}`,
        fail: function () {
          wx.miniProgram.switchTab({ url: `/${link}` });
        },
      });
    },
    playVideo(i) {
      this.isPlay = true
      // console.log(this.$refs['video' + i])
      this.$refs['video' + i][0].play();
      // this.$refs['video' + i][0].requestFullScreen()
    },
    clickClose(i) {
      this.isPlay = false
      this.$refs['video' + i][0].pause()
    },
    handleSign(item){
      if(this.$configInfo.status != 3){
        return this.$showToast("活动未开始!", "提示");
      }

      if(item.signUpFlag){
        // this.signUpDetail
        this.showQrCode(item)
        return 
      }
      if(item.totalSwitch&&item.signUpTotal>=item.total){
        return this.$showToast("您来晚了!报名人数已满!", "提示");
      }
      const currentTime=new Date().getTime()
      let type='sign'
      if(item.signUpStartTime>currentTime||item.signUpEndTime<currentTime){
        type='8897'
      }
      this.$modal.signForm.alert({
        type: type,
        code: item.code,
        info:item
      }).then(()=>{
        this.$emit('upData')
      });
    },
    async showQrCode(item){
      let url = this.$apizt.action.signUpDetail;
      const params={
        actCode:this.$actCode,
        openId:this.$openid,
        prizeCode:item.code
      }
      const {code,data}= await this.$httpzt.requestRestFul(url, params,'post');
      if(code==200){
        console.log(data)
        this.$modal.qrCode.alert({
          ...data,
          prizeType:'sign'
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid;
  box-sizing: border-box;

  &.lightup {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  &.theme2 {
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background: rgba(255, 255, 255, 0.1);

    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }

  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index: 1;

    &.lightup {
      margin-top: -10px;
      border-radius: 0px 0px 12px 12px;
    }
  }

  .modelBg {
    width: 100%;
    //    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      width: 100%;
      border-radius: 7px;

      .item {
        position: relative;
        overflow: hidden;

        &.spacing {
          margin-top: 10px;
        }

        &.borderTop {
          border-radius: 7px 7px 0 0;
        }

        &.borderBottom {
          border-radius: 0 0 7px 7px;
        }

        &.borderAll {
          border-radius: 7px;
        }

        &.video {
          .play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 96px;
            height: 96px;
            background: url('https://assets.rurushishi.com/activies/activityCenter/play-icon.png') 0 0 / 100% no-repeat;
          }
        }

        .video-box {
          position: relative;
          // &::after {
          //   position: absolute;
          //   top: 50%;
          //   left: 50%;
          //   transform: translate(-50%, -50%);
          //   width: 96px;
          //   height: 96px;
          //   background: url('https://assets.rurushishi.com/activies/activityCenter/play-icon.png') 0 0 / 100% no-repeat;
          //   z-index 10000;
          // }
          // .itemVideo {
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   width: 100%;
          //   height: 100%;
          // }
        }

        .video-box2 {}

        .full-video-box {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;

          .close {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            // z-index: 1002;
          }
        }

        .itemVideo {
          width: 100%;
        }

        .itemImg {
          width: 100%;
        }

        .go-btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        &.sign {
          padding: 26px 15px 15px;
          background-color: rgba(255, 255, 255, 0.9);

          .name {
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            color: #262626;
          }

          .info {
            display: flex;
            font-size: 12px;
            line-height: 24px;

            .label {
              color: #8C8C8C;
              margin-right: 5px;
            }

            .intro {
              flex: 1;
              color: #262626;
              span{
                font-size: 14px;
              }
            }
          }

          .button {
            width: (283px);
            height: (40px);
            top: 424px;
            left: 24px;
            padding: 8px 24px 8px 20px;
            border-radius: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            margin: 20px auto 0;
            border: 1px solid transparent;

            .icon {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }

          .signUserList {
            margin:20px auto 0;
            .title {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 14px;

              .line {
                font-size: 14px;
                line-height: 20px;
                height:1px;
                width:112px;
              }
            }

            .userList {
              max-height:320px;
              overflow: auto;
              .item {
                width: 100%;
                display: flex;
                height: 64px;
                align-items: center;
                justify-content: space-between;

                .userImg {
                  width: 32px;
                  height: 32px;
                  border-radius: 16px;
                }

                .userName {
                  flex: 1;
                  padding: 0 16px;
                  font-weight: normal;
                  font-size: 16px;
                  line-height: 24px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .time {
                  font-size: 12px;
                  line-height: 24px;
                  text-align: center;
                  color: #8C8C8C;
                }

              }
            }
            .more{
              font-size: 12px;
              line-height: 24px;
              width:104px;
              height: 24px;
              border-radius: 100px;
              text-align: center;
              margin: auto;
            }
          }

        }
      }
    }
  }
}</style>
